import React, { useState } from 'react';
import _ from 'lodash';
import { Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import { faShippingFast } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

_.mixin(require('lodash-uuid'));

function VindenDeliveryImageOverlay({ size, article }) {
  if (article.onCopack) return <></>;
  const [isOpen, setIsOpen] = useState(false);
  const toolTipTargetId = ['VindenDeliveryImageOverlay', article.id].join('-');

  const toggleTooltip = () => setIsOpen(!isOpen);

  return (
    <span className="text-muted" id={toolTipTargetId}>
      <FontAwesomeIcon size={size} icon={faShippingFast} className="" />
      <Tooltip
        isOpen={isOpen}
        target={toolTipTargetId}
        toggle={toggleTooltip}
        placement="top-end"
      >
        Samlad leverans
      </Tooltip>
    </span>
  );
}
export default VindenDeliveryImageOverlay;

VindenDeliveryImageOverlay.propTypes = {
  size: PropTypes.string,
  article: PropTypes.object.isRequired,
};

VindenDeliveryImageOverlay.defaultProps = {
  size: 'sm',
};
